/**
 * HTTP status codes used across API response parsers.
 * Add new codes here as they are needed rather than sprinkling magic numbers.
 */
/* eslint-disable no-shadow, no-unused-vars */
// eslint-disable-next-line import/prefer-default-export
export enum HttpStatus {
  OK = 200,
  NOT_FOUND = 404
}
/* eslint-enable no-shadow, no-unused-vars */
